import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Dialog, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { PAGE_NAMES, CORPORATE_REGFORM_URL, PUBLIC_REGFORM_URL } from 'appenv';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const StyledDialog = withStyles(() => ({
  container: {
    width: '100%',
  },
  paper: {
    borderRadius: '8px',
  },
  paperFullScreen: {
    borderRadius: '8px 8px 0 0',
    maxHeight: '325px',
  },
  scrollPaper: {
    alignItems: ({ fullScreen }) => (fullScreen ? 'flex-end' : 'center'),
  },
}))(Dialog);

const StyledModal = styled.div`
  width: 100%;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 960px) {
    position: initial;
    padding: 16px 28px 60px;
    height: auto;
    max-width: 400px;
  }
`;

const Button = styled.button`
  width: 100%;
  border-radius: 4px;
  padding: 12px;
  margin: 8px 0;
  font-size: 18px;
  line-height: 18px;
  outline: none;
  color: #FFF;
  border: none;
  background-color: ${({ bgColor }) => (bgColor)};
  cursor: pointer;
`;

const StyledTitle = styled.h2`
  text-align: center;
`;

const StyledCloseIcon = styled(CloseIcon)`
  font-size: 28px;
  color: #A2AAB3;
  cursor: pointer;
  margin-left: -10px;

  @media only screen and (min-width: 960px) {
    align-self: flex-end;
    margin-right: -10px;
  }
`;

const ModalTransition = React.forwardRef((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Slide direction="up" ref={ref} mountOnEnter unmountOnExit {...props} />
));

const RegisterModal = ({ open, handleClose }) => {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width: 960px)');

  return (
    <StyledDialog
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      TransitionComponent={ModalTransition}
      fullScreen={isMobile}
    >
      <StyledModal>
        <StyledCloseIcon onClick={handleClose} />
        <StyledTitle id="transition-modal-title">
          Please select
        </StyledTitle>
        <Button
          bgColor="#0CA58B"
          onClick={() => {
            window.open(CORPORATE_REGFORM_URL, '_blank');
          }}
        >
          Business & Investment Matching
          <br />
          (For Corporate)
        </Button>
        <Button
          bgColor="#0E7ABC"
          onClick={() => {
            window.open(PUBLIC_REGFORM_URL, '_blank');
          }}
        >
          {PAGE_NAMES.webinar}
          <br />
          (For Public)
        </Button>
      </StyledModal>
    </StyledDialog>
  );
};

RegisterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default RegisterModal;
